<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

import {domAppendJs} from "@/util/util";
import Vue from 'vue';
export default {
  name: "App",
  created(){
    if (process.env.NODE_ENV !== 'development') {
      this.loadJS();
    }
  },
    methods:{
    //加载 错误监听js
    loadJS() {
      domAppendJs(
        "//x.autoimg.cn/2sc/m/capture_error/capture_error.js",
        () => {
          domAppendJs(
            "//x.autoimg.cn/2sc/m/capture_error/capture_error_call.js",
            () => {
              this.captureErrorInit();
            },
            "capture_error_call"
          );
        },
        "capture_error"
      );
    },
    //加载监听错误
    captureErrorInit() {
      Vue.use(CAPTURE_PLUGIN.MitoVue);
      CAPTURE_INIT([CAPTURE_REQUEST, CAPTURE_RESOURCE, CAPTURE_CODE], (res) => {
        var dataparams = JSON.stringify(res);
        dataparams = JSON.stringify([dataparams]);
        let url = `//2sckfkapi.che168.com/applog/send?_appid=2sc.m`
        this.$axios({
          method: 'post',
          url: url,
          transformRequest: [function (data, headers) {
            return data;
          }],
          data:dataparams,
        })
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue